import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {

    class: string = '';
    
    ngOnInit(): void {
    }

    openSidebar(): void {
        console.log('openSidebar()');
        this.class = 'visible';
    }

    closeSidebar(): void {
        console.log('closeSidebar()');
        this.class = '';
    }
}
